import { render, staticRenderFns } from "./StockCostValue.vue?vue&type=template&id=532775fc&scoped=true"
import script from "./StockCostValue.vue?vue&type=script&lang=js"
export * from "./StockCostValue.vue?vue&type=script&lang=js"
import style0 from "./StockCostValue.vue?vue&type=style&index=0&id=532775fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532775fc",
  null
  
)

export default component.exports